module.exports = __webpack_public_path__ + "img/logo.8ccc56d7.png";